import { render, staticRenderFns } from "./AddSerialNumber.vue?vue&type=template&id=696cb413&scoped=true"
import script from "./AddSerialNumber.vue?vue&type=script&lang=js"
export * from "./AddSerialNumber.vue?vue&type=script&lang=js"
import style0 from "./AddSerialNumber.vue?vue&type=style&index=0&id=696cb413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696cb413",
  null
  
)

export default component.exports